export default "__VITE_PUBLIC_ASSET__33e98745__"